import { render, staticRenderFns } from "./WriteDocument.vue?vue&type=template&id=8d15c62c&scoped=true"
import script from "./WriteDocument.vue?vue&type=script&lang=js"
export * from "./WriteDocument.vue?vue&type=script&lang=js"
import style0 from "./WriteDocument.vue?vue&type=style&index=0&id=8d15c62c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d15c62c",
  null
  
)

export default component.exports